module.exports = __webpack_public_path__ + "static/chitranshu-ce2f518ef799741868670723ca29b5f2.png";